import styled from 'styled-components';
import { ImageUtils } from '../../../utils/ImageUtils';
import { mobileQuery } from '../../../utils';

export const OfflineInfo = () => {
  return (
    <Container>
      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon1}></NumberIcon>
          <Title>
            오프라인 이벤트 DAY 1 <span>▶</span> 오프라인 티켓 보유자
          </Title>
        </TitleContainer>
        <Content>
          <Row>
            <EventTypeText type={'A'}>[메인 이벤트] {` `}</EventTypeText>
            <EventContainer>
              <EventInfoText>3월 21일(토) 오후 12시</EventInfoText>
              <EventTimeText>오전 11시 30분부터 입장 가능합니다.</EventTimeText>
            </EventContainer>
          </Row>
          <Row>
            <EventTypeText type={'B'}>[사이드 이벤트]</EventTypeText>
            <EventContainer>
              <EventInfoText>3월 22일(일) 오후 12시</EventInfoText>
              <EventTimeText>오전 11시 30분부터 입장 가능합니다.</EventTimeText>
            </EventContainer>
          </Row>
          <Row>
            <EventContainer $mobileHasIcon>
              <EventInfoText>
                <span>
                  <img src={ImageUtils.LocationIcon} alt="" />
                </span>
                장소 추후 공지
              </EventInfoText>
              {/* <EventTimeText>서울 서대문구 연희로 353</EventTimeText> */}
            </EventContainer>
          </Row>

          <WaringContainer>
            <WaringItem>
              오프라인 이벤트 티켓은 메인 이벤트, 사이드 이벤트 모두 사용 가능합니다.
            </WaringItem>
            <WaringItem>
              사용하지 않은 오프라인 이벤트 티켓은 이벤트 종료 후 1장당 <span> 35억 골드 박스</span>
              로 교환 예정입니다.
            </WaringItem>
          </WaringContainer>
        </Content>
      </Item>

      <Item>
        <TitleContainer>
          <NumberIcon src={ImageUtils.NumberIcon2}></NumberIcon>
          <Title>
            오프라인 이벤트 DAY 2 <span>▶</span> DAY 2 참가 티켓 소지자
          </Title>
        </TitleContainer>
        <Content>
          <Row>
            <EventTypeText type={'A'}>[메인 이벤트]</EventTypeText>
            <EventContainer>
              <EventInfoText>3월 22일(일) 오전 11시</EventInfoText>
              <EventTimeText>오전 10시30분부터 입장 가능합니다.</EventTimeText>
            </EventContainer>
          </Row>

          <Row>
            <EventContainer $mobileHasIcon>
              <EventInfoText>
                <span>
                  <img src={ImageUtils.LocationIcon} alt="" />
                </span>
                장소 추후 공지
              </EventInfoText>
              {/* <EventTimeText>서울 서대문구 연희로 353</EventTimeText> */}
            </EventContainer>
          </Row>
        </Content>
      </Item>
    </Container>
  );
};

const Container = styled.div`
  max-width: 820px;
  margin: 0 auto;
`;

const Item = styled.div`
  margin-bottom: 30px;
  padding-bottom: 30px;
  border-bottom: 1px solid rgba(112, 112, 112, 0.5);

  &:last-child {
    margin-bottom: 0;
    border-bottom: none;
  }
  ${mobileQuery} {
    margin-bottom: 10px;
    padding-top: 0;
    padding-bottom: 10px;
  }
`;

const TitleContainer = styled.div`
  margin-bottom: 7px;
  display: flex;
  align-items: center;
`;

const Title = styled.h3`
  font-weight: 400;
  font-size: 22px;
  line-height: 28px;
  letter-spacing: -0.04em;
  color: #fff;
  margin: 0;

  span {
    font-size: 16px;
    position: relative;
    top: -2px;
    margin-left: 6px;
    margin-right: 6px;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 17px;

    span {
      font-size: 10px;
      top: -1px;
    }
  }
`;

const Content = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  padding-left: 40px;

  ${mobileQuery} {
    padding-left: 14px;
  }
`;

const NumberIcon = styled.img`
  width: 28px;
  height: 28px;
  margin-right: 6px;

  ${mobileQuery} {
    width: 18px;
    height: 18px;
    margin-right: 6px;
  }
`;

const EventTypeText = styled.h3<{ type?: 'A' | 'B' | 'C' }>`
  color: ${({ type }) => (type === 'A' ? '#FD4896' : type === 'B' ? '#4F7CF0' : '#AA6DFF')};
  font-size: 22px;
  font-weight: 600;
  line-height: 34px; /* 154.545% */
  margin-bottom: 8px;
  display: flex;

  i {
    color: white;
    font-style: italic;
    text-decoration-line: underline;
    font-size: 20px;
    float: right;
    margin-left: 10px;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 24px;
    margin-bottom: 0;

    i {
      float: none;
      font-size: 12px;
    }
  }
`;

const EventContainer = styled.div<{ $mobileHasIcon?: boolean }>`
  display: flex;
  justify-content: space-between;

  ${mobileQuery} {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;

    padding-left: ${({ $mobileHasIcon }) => ($mobileHasIcon ? '25px' : '0')};
    background-image: ${({ $mobileHasIcon }) =>
      $mobileHasIcon ? `url(${ImageUtils.LocationIcon})` : 'none'};
    background-size: 21px 21px;
    background-repeat: no-repeat;
    background-position: left center;
  }
`;

const EventInfoText = styled.p`
  color: rgba(255, 255, 255, 0.8);
  font-size: 22px;
  font-weight: 500;
  line-height: 24px;

  img {
    margin-top: 8px;
  }
  span {
    margin-right: 10px;
  }

  ${mobileQuery} {
    font-size: 16px;
    line-height: 22px;

    span {
      display: none;
    }
  }
`;

const EventTimeText = styled.p`
  color: rgba(255, 255, 255, 0.4);
  text-align: right;
  font-size: 20px;
  font-weight: 500;
  line-height: 24px; /* 120% */

  ${mobileQuery} {
    font-size: 16px;
    line-height: 22px;
  }
`;

const Row = styled.div`
  margin-bottom: 12px;
`;

const WaringContainer = styled.ul`
  list-style: none;
  margin: 0;
  padding: 0;
  padding-left: 30px;

  ${mobileQuery} {
    padding-left: 10px;
  }
`;

const WaringItem = styled.li`
  color: #8e8e8e;

  font-size: 20px;
  font-style: normal;
  font-weight: 400;
  line-height: 30px;
  letter-spacing: -0.96px;
  position: relative;

  span {
    color: white;
    text-decoration: underline;
  }

  &:after {
    content: '';
    width: 6px;
    height: 6px;
    background: #8e8e8e;
    border-radius: 50%;
    position: absolute;
    left: -20px;
    top: 10px;
  }

  ${mobileQuery} {
    font-size: 14px;
    line-height: 22px;

    &:after {
      width: 4px;
      height: 4px;
      left: -8px;
      top: 7px;
    }
  }
`;
